import { flare } from "@flareapp/js";

if (process.env.NODE_ENV === 'production') {
    flare.light(process.env.FLARE_JS_KEY);
}

if(typeof String.prototype.trim !== 'function') {
	String.prototype.trim = function() {
		return this.replace(/^\s+|\s+$/g, '');
	}
}

$(document).ready(function(){

	$(document).ajaxStart(function(){
		$("#saving").stop(true, true).fadeIn(100);
		$("#saving div").removeClass('saved success').addClass('saving info').html('Saving form...');
	}).ajaxStop(function(){
		$("#saving div").removeClass('saving info').addClass('saved success').html('Saved form!');
		$("#saving").stop(true, true).delay(2000).fadeOut(1000);
	});


	var countWords = function($el) {
		var maxwords = $el.attr('data-maxlength');
		var length = $el.val().trim().split(' ').filter(function(n){return n;}).length;
		var left = maxwords - length;

		$el.parent().find('.length').text('(' + left + ' words left)');
		$el.on('keydown keyup', function(){
			var key = event.which || event.keyCode || event.charCode;
			var maxwords = $el.attr('data-maxlength');
			var length = $el.val().trim().split(' ').filter(function(n){return n;}).length;
			var left = maxwords - length;
			// console.log($el.val().trim().split(' ').filter(function(n){ return n != undefined }).length);
			$el.parent().find('.length').text('(' + left + ' words left)');
			if (left <= 0 && key == 32){
				return false;
			}
		});
	};

	$(".maxlength").each(function(){
		countWords($(this));
		var left = $(this).offset().left - $(this).parent().offset().left;
		$(this).parent().find('.length').css('marginLeft', left + 'px');
	});

	/*
	$(".maxlength").each(function(){
		var maxchars = $(this).attr('maxlength');
		var left = maxchars - $(this).val().length;
		$(this).next().text('(' + left + ' chars left)');
		$(this).keyup(function(){
			var maxchars = $(this).attr('maxlength');
			var left = maxchars - $(this).val().length;
			$(this).next().text('(' + left + ' chars left)');
			if (left === 0){
				return false;
			}
		});
	});
*/

	$("#apply, #reference, #selectors").tabs({ cookie: {} });

	// Periodic save to avoid timeouts
	// let createSaveInterval = function () {
	// 	return setInterval(function () {
	// 		$("#apply, #reference, #selectors").trigger('change');
	// 	}, 30000);
	// }
	// let interval = createSaveInterval();

	// saveForm
	let saveForm = function () {
		// clearInterval(interval);

		var data = $(this).serialize() + '&ajax=1';
		var target = $(this).attr('target');
		$.post(target, data, function(response) {
			if (!response) {
				alert('You have been logged out. This could either be because of a log in elsewhere, or a session timeout.');
				window.location.href = '/';
				return;
			}
			if (response !== true) {
				flare.report(new Error('Form save failed for ' + target + ': ' + JSON.stringify(response)));
			}
			// interval = createSaveInterval();
		}, 'json').fail(function(jqXHR) {
			flare.report(new Error('Form save request failed for ' + target + ' (' + jqXHR.status + '): ' + jqXHR.responseText));
		});
	}

	$("#apply, #reference, #selectors").on('change', saveForm);

	$("#apply p.next button").click(function(e){
		e.preventDefault();
		$(".tabs").tabs('option', 'selected', $(".tabs").tabs('option', 'selected') + 1);
		$.scrollTo("#container", 500);
		return false;
	});

	$(".delete").on('click', function(){
		var $this = $(this);
		$("#delete").dialog({
			resizable: false,
			height:140,
			modal: true,
			buttons: {
				"Delete Item": function() {
					$this.parents('tr').remove();
					$("#apply").trigger('change');
					$(this).dialog("close");
				},
				Cancel: function() {
					$(this).dialog("close");
				}
			}
		});
		return false;
	});

	$(".duplicate").click(function(e){
		e.preventDefault();
		var $table = $(this).parent().parent().find('.multiform tbody');
		$table.find('tr:first').clone().appendTo($table);
		$table.find('tr:last input, tr:last select, tr:last textarea').val('');
		countWords($table.find("tr:last textarea.maxlength"));
		$("#apply").trigger('change');
		return false;
	});


	$(".referee-save input").click(function(){
		if (!confirm('On submitting this referee\'s details, you will be unable to make futher edits to this section of the form.\n\nYour referee will also be sent an automated email asking them to complete their reference for you.\n\nYou will not be able to submit the rest of this form until both referees have submitted references for you.\n\nContinue?')){
			return false;
		}
		var $this = $(this);
		var rid = $(this).attr('data-referee');
		$.post('/referee', {
			'referee_id': rid,
			'reference_name': $('#reference'+rid+'_name').val(),
			'reference_position': $('#reference'+rid+'_position').val(),
			'reference_email': $('#reference'+rid+'_email').val(),
			'reference_tel': $('#reference'+rid+'_tel').val(),
			'reference_address': $('#reference'+rid+'_address').val(),
			'reference_years': $('#reference'+rid+'_years').val(),
		}, function(data){
			if (data.status == 'OK') {
				window.location.reload();
			}else{
				$('<div class="formerrors"><ul class="errors"></ul></div>').insertAfter($this.parent());

				if (Array.isArray(data.errHelp) && data.errHelp.length > 0) {
					data.errHelp.forEach(function(msg) {
						$("ul.errors").append('<li>' + msg + '</li>');
					});
				}
			}
		}, 'json');
	});

	$(".tabs .ui-tabs-panel:last p.next").remove();

	$("#apply").submit(function(){
		if (!confirm('On submitting this form you are confirming that all information entered is, to the best of your knowledge, correct.\n\nPlease be aware that your referees will automatically be emailed after clicking ok below.\n\nYou WILL NOT be able to make further modifications to your application.\n\nContinue?')){
			return false;
		}
	});

	$("#reference").submit(function(){
		if (!confirm('On submitting this form you are confirming that all information entered is, to the best of your knowledge, correct.\n\nYou do not need to press this button to save your form (it will save automatically).\n\nYou WILL NOT be able to make further modifications to your reference after submitting this.\n\nContinue?')){
			return false;
		}
	});

	$("#selectors").submit(function(){
		if (!confirm('You do not need to press this button to save your form (it will save automatically).\n\nYou WILL NOT be able to make further modifications to your scoring form after submitting this.\n\nContinue?')){
			return false;
		}
	});

	$("div.formerrors ul.errors a").click(function(){
		var id = $(this).attr('href');
		var $tab = $(id).parents('div.ui-tabs-panel');
		$(".tabs").tabs('option', 'selected', $tab.index() - 1);
		$.scrollTo(id, 500);
		$(id).focus();
		return false;
	});

});


var saveTimer;
var saveContent = function(ed){
	$("#"+ed.editorId).html(ed.getContent());
	$("#"+ed.editorId).trigger('change');
};


/*
 *  TinyMCE editor
 */
tinyMCE.init({
	//plugins : "autolink,lists,spellchecker,pagebreak,style,layer,table,save,advhr,advimage,advlink,emotions,iespell,inlinepopups,insertdatetime,preview,media,searchreplace,print,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template",
	theme : "advanced",
	mode : "textareas",
	editor_selector : "tinymce",
	theme_advanced_toolbar_location : "top",
	theme_advanced_toolbar_align : "left",
	theme_advanced_statusbar_location : "bottom",
	theme_advanced_buttons1 : "undo,redo,|,cut,copy,paste,|,bold,italic,underline,|,justifyleft,justifycenter,justifyright,justifyfull,|,bullist,numlist,|,formatselect",
	theme_advanced_buttons2 : "",
	theme_advanced_buttons3 : "",
	theme_advanced_blockformats : "p,h1,h2,h3,h4,h5,h6",
	theme_advanced_resizing : true,
	theme_advanced_resize_horizontal : false,
	setup : function(ed) {
		ed.onChange.add(function(ed) {
			$("#"+ed.editorId).html(ed.getContent());
			$("#"+ed.editorId).trigger('change');
		}),
		ed.onKeyUp.add(function(ed) {
			clearTimeout(saveTimer);
			saveTimer = setTimeout(function(){ saveContent(ed); }, 2000);
		})
	}
});


